<template>
  <div v-loading="loading" class="approval-manage content-wrapper-with-tabs">
    <div class="approval-header">
      <div class="cw-tabs mb-0 h-[55px]">
        <div
          v-for="(v, idx) in tabList"
          :key="idx" 
          v-permission="v.code" 
          :class="{ active: activeIndex === idx }"
          @click="changeTab(idx)"
        >
          {{ v.name }} 
        </div>
      </div>
      <el-pagination
        :page-size="6"
        layout="prev, pager, next"
        :total="pageParams.total"
        @current-change="onCurrentPageChange"
      />
    </div>

    <component 
      :is="curComponent" 
      :is-company-identity="isCompanyIdentity"
      :page-params="pageParams"
      @update:total="onTotalChange"
      @update:loading="onLoadingChange"
    />
  </div>
</template>

<script setup lang="ts">
import PendingApproval from '../widgets/PendingApproval.vue';
import InitiateApproval from '../widgets/InitiateApproval.vue';
import { computed, markRaw, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useUserStore } from '@core/main';
import { ESystemType } from '@core/api';

const { state: userState } = useUserStore();

const route = useRoute();

const pageParams = ref({
  page: 1,
  size: 6,
  total: 0,
});
const loading = ref(false);
const activeIndex = ref(route.query && route.query.activeIndex ? Number(route.query.activeIndex) : 0);
const tabList = ref([
  {
    name: '待我审批',
    component: markRaw(PendingApproval),
    code: ['approval:manage:pending'],
    actinveIndex: 0,
  },
  {
    name: '我发起的审批',
    component: markRaw(InitiateApproval),
    code: ['approval:manage:record'],
    activeIndex: 1,
  },
]);

const curComponent = computed(() => tabList.value[activeIndex.value].component);
const isCompanyIdentity = computed(() => userState.identity.systemType === ESystemType.Company);

function changeTab(idx: number) {
  if (idx === activeIndex.value) return;

  activeIndex.value = idx;
  pageParams.value.page = 1;
  pageParams.value.total = 0;
}

function onCurrentPageChange(page: number) {
  pageParams.value.page = page;
}

function onTotalChange(total: number) {
  pageParams.value.total = total;
}

function onLoadingChange(val: boolean) {
  loading.value = val;
}
</script>

<style lang="scss" scoped>
.approval-manage {
  @apply w-full bg-white rounded;

  .approval-header {
    @apply flex items-center justify-between;

    .cw-tabs {
      .active {
        @apply text-[18px] font-[550];
      }
    }
  }
}
</style>
